<div class="print-container">
    <h1 class="page-label">Order Validation - Select Portal</h1>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <div class="col-sm-3" style="text-align:right">
                <label class=" input-label" for="portal-input">Portal:</label>
                
                  </div>  
                  <div class="col-sm-6">
                <select [(ngModel)]="selectedPortal" class="col-sm-6 form-control" id="portal-input" [disabled]="isUiDisabled">
                    <option [ngValue]="null"> -- Choose -- </option>
                    <option *ngFor="let portal of availablePortals" [ngValue]="portal">
                        {{ portal.name }}
                    </option>
                </select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onSelectPortalClicked()" class="submit btn btn-primary col-sm-3" [disabled]="isUiDisabled">SELECT PORTAL</button>
    </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>